/** Builds TaskListBase controller render payload from assembled list state. */
export function buildTaskListBaseControllerResult({
  id,
  isSortable,
  dragEnabled,
  items,
  uiContextValue,
  taskListRef,
  tasks,
  tasksMap,
  showBreadcrumbs,
  view,
  topActionableTaskId,
  showPlayButtonAlways,
  handleFocus,
  handleBlur,
  indentationType,
  newTaskInputIndex,
  newTask,
  handleCancelNewTaskInput,
  editingTaskId,
  listActions,
  onBeforeToggleComplete,
  listTabIndex,
  itemTabIndex,
  buildTaskListBaseContent,
}) {
  const content = buildTaskListBaseContent({
    uiContextValue,
    taskListRef,
    tasks,
    tasksMap,
    showBreadcrumbs,
    view,
    topActionableTaskId,
    showPlayButtonAlways,
    handleFocus,
    handleBlur,
    indentationType,
    newTaskInputIndex,
    handleSaveNewTask: newTask.handleSaveNewTask,
    handleCancelNewTaskInput,
    triggeringKey: newTask.triggeringKey,
    editingTaskId,
    handleSave: listActions.handleSave,
    handleStopEditingAndRestoreSelection:
      listActions.handleStopEditingAndRestoreSelection,
    addingSubtaskTo: listActions.addingSubtaskTo,
    handleStartAddingSubtask: listActions.handleStartAddingSubtask,
    handleSaveSubtask: listActions.handleSaveSubtask,
    handleCancelAddSubtask: listActions.handleCancelAddSubtask,
    onBeforeToggleComplete,
    listTabIndex,
    itemTabIndex,
  });

  return { id, isSortable, dragEnabled, items, content };
}
